// @material-ui/icons
import Flight from "@material-ui/icons/Flight";
import Audit from "@material-ui/icons/TrackChanges";
import AirlinePaymentPage from "views/AirlinePayment/Index.jsx";
import NotFound from "views/NotFound/Index.jsx";



const routes = [
    {
        path: "/app/airline-payment",
        sidebarName: "Airline Payment",
        navbarName: "Airline Payment Report",
        icon: Flight,
        subMenu: [],
        component: AirlinePaymentPage
    },

    {
        isNotVisible: true,
        path: "**",
        sidebarName: "Not found",
        navbarName: "Not Found",
        icon: Audit,
        subMenu: [],
        component: NotFound,

    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/accounts.jsx